<template lang="pug">
  v-card(v-if="!cargando")
    v-card-text
      v-tabs(v-if="tipo_viaje === 'vuelta'" v-model="tab" color="secondary" slider-color="primary" slider-size="4")
        v-tab(v-for="(trayecto, t) in capacidades", :key="t")
          | {{ tipo(t) }}
          v-badge.ml-2(v-if="errores[t]" color="error" dot)
      v-tabs-items(v-model="tab")
        v-tab-item(v-for="(trayecto, t) in capacidades", :key="t")
          div.my-6.text-h6.font-weight-light Elija <b>{{ pasajeros.length }}</b> butaca{{ pasajeros.length === 1 ? '' : 's' }} para el viaje de <b>{{ tipo(t) }}</b>:
          v-row
            v-col(cols="12" md="6")
              div.text-body-1.font-weight-light Nave: <b>{{ itinerario[tab].Nave }}</b>
              div.text-body-1.font-weight-light Asientos disponibles: <b>{{ trayecto.length }}</b>
              div.text-body-1.font-weight-light Asientos seleccionados: <b>{{ n[tab] }}</b>
            v-col(cols="12" md="6")
              v-card(outlined)
                div.text-center.overline Simbología Butacas
                v-card-text.py-0
                  div.my-2.d-flex
                    div.mr-2.butaca
                    div.text-caption Disponible
                  div.my-2.d-flex
                    div.mr-2.butaca_preferencial
                    div.text-caption Preferencial
                  div.my-2.d-flex
                    div.mr-2.butaca.nodisponible
                    div.text-caption No disponible
          div.mt-6.butacas
            div.text-overline.text-center Proa
            div.text-center.justify-center(v-if="ready" v-for="r in barco.settings.rows", :key="r")
              div(v-for="c in barco.settings.cols", :key="c", :title="butacasArr[r-1][c-1].title" v-bind:class="getClass(butacasArr[r-1][c-1])" @click="clickButaca(r-1, c-1)")
            div.text-overline.text-center Popa

    v-card-actions
      v-btn.mx-3.mb-3(color="primary" @click="$emit('prev')", :disabled="loading")
        v-icon(left) mdi-chevron-left
        | Volver
      v-spacer
      v-btn.mx-3.mb-3(color="secondary" @click="validar", :loading="loading")
        | Continuar
        v-icon(right) mdi-chevron-right

  v-card(v-else min-height="600")
    v-card-text
      v-row.fill-height.text-center(align-content="center" justify="center")
        v-col(cols="12")
          div.text-body-1 Buscando butacas disponibles...
        v-col(v-if="!error" cols="8")
          v-progress-linear(color="secondary" indeterminate rounded)
        v-col(v-else cols="8")
          v-btn(color="primary" @click="iniciar") Reintentar
            v-icon(right) mdi-refresh
</template>

<script>

import barcos from '@/assets/barcos'

export default {
  name: 'Butacas',

  components: {
  },

  data: () => ({
    tab: 0,
    barcos: barcos,
    butacas: [],
    butacas_ida: [],
    butacas_vuelta: [],
    ready: false,
    cargando: true,
    n: [0, 0],
    errores: [false, false],
    error: false
  }),

  watch: {
  },

  computed: {
    capacidades () {
      return this.$store.state.capacidad
    },

    itinerario () {
      return this.$store.state.itinerario
    },

    barco () {
      return this.barcos[this.itinerario[this.tab].Nave.toLowerCase()]
    },

    butacasArr () {
      if (this.tab === 1) {
        return this.butacas_vuelta
      } else {
        return this.butacas_ida
      }
    },

    pasajeros () {
      return this.$store.state.pasajerosArr
    },

    tipo_viaje () {
      return this.$store.state.tipo_viaje
    },

    loading () {
      return this.$store.state.prereservaLoading
    },

    duplicada () {
      return this.$store.state.prereserva === null
    }
  },

  mounted () {
    this.iniciar()
  },

  methods: {
    async iniciar () {
      this.error = false
      this.n = [0, 0]
      await this.buscar_butacas().catch(() => {
        return
      })
      this.inicializar_butacas()
      this.marcar_butacas_disponibles()
      if (this.duplicada) {
        // this.limpiar_butacas_seleccionadas()
        this.$store.commit('LIMPIAR_BUTACAS')
      } else {
        this.marcar_butacas_seleccionadas()
      }

      // this.$store.commit('SET_PRERESERVA', [null, null])

      this.ready = true
    },

    async buscar_butacas () {
      let ids = []
      for (let i = 0; i < this.itinerario.length; i++) {
        if (this.itinerario[i] !== null && this.itinerario[i] !== undefined) {
          ids.push(this.itinerario[i].Itinerario)
        }
      }
      await this.$store.dispatch('getCapacidad', ids).catch(() => {
        this.error = true
        this.$store.dispatch('notify', {
          color: 'error',
          text: 'Hubo un error. Por favor intente nuevamente',
          icon: 'mdi-alert-circle',
          timeout: 5000
        })
        throw this.error
      })
      this.cargando = false
    },

    inicializar_butacas () {
      this.butacas_ida = []
      this.butacas_vuelta = []
      this.butacas = []
      for (let i = 0; i < this.itinerario.length; i++) {
        if (!this.itinerario[i]) {
          continue
        }
        this.butacas.push({})
        const nave = this.itinerario[i].Nave.toLowerCase()
        const barco = this.barcos[nave]
        let butacas
        if (i === 1) {
          butacas = this.butacas_vuelta
        } else {
          butacas = this.butacas_ida
        }

        for (let r = 0; r < barco.settings.rows; r++) {
          const fila = []
          for (let c = 0; c < barco.settings.cols; c++) {
            const asiento = barco.model[r][c]
            const butaca = {
              'disabled': asiento === '_',
              'nodisponible': true,
              'checked': false,
              'title': asiento !== '_' ? asiento : undefined,
            }
            butaca.class = butaca.disabled ? 'disabled' : 'nodisponible'
            fila.push(butaca)
            if (butaca.title) {
              this.butacas[i][butaca.title] = butaca
            }
          }
          butacas.push(fila)
        }
      }
    },

    marcar_butacas_disponibles () {
      for (let c = 0; c < this.capacidades.length; c++) {
        if (!this.butacas[c] || !this.capacidades[c]) {
          continue
        }
        for (let b = 0; b < this.capacidades[c].length; b++) {
          let numero = parseInt(this.capacidades[c][b].n)
          if (!this.butacas[c][numero]) {
            continue
          }
          if (!this.capacidades[c][b].cd) {
            this.butacas[c][numero].nodisponible = true
            this.butacas[c][numero].class = 'nodisponible'
            this.butacas[c][numero].label = this.capacidades[c][b].n
          } else {
            this.butacas[c][numero].nodisponible = false
            this.butacas[c][numero].class = ''
            this.butacas[c][numero].label = this.capacidades[c][b].n
          }
        }
      }
    },

    marcar_butacas_seleccionadas () {
      for (let c = 0; c < this.capacidades.length; c++) {
        const tipo = this.tipo(c)
        const butacas = this['butacas_' + tipo]
        for (let p = 0; p < this.pasajeros.length; p++) {
          if (this.pasajeros[p][tipo]) {
            const row = this.pasajeros[p][tipo].r
            const col = this.pasajeros[p][tipo].c
            if (butacas && row !== undefined && col !== undefined && butacas[row] && butacas[row][col]) {
              if (butacas[row][col].nodisponible && this.duplicada) {
                continue
              }
              butacas[row][col].checked = true
              butacas[row][col].class = 'checked'
              butacas[row][col].nodisponible = false
              this.n[c]++
            }
          }
        }
      }
    },

    limpiar_butacas_seleccionadas () {
      for (let c = 0; c < this.capacidades.length; c++) {
        const tipo = this.tipo(c)
        for (let p = 0; p < this.pasajeros.length; p++) {
          this.pasajeros[p][tipo] = undefined
        }
      }
    },

    tipo (t) {
      if (t === 1) {
        return 'vuelta'
      } else {
        return 'ida'
      }
    },

    clickButaca(r, c) {
      let butaca = this.butacasArr[r][c]
      let index
      const tipo = this.tipo(this.tab)

      if (butaca.nodisponible) {
        return
      }

      if (!butaca.checked) {
        if (this.n[this.tab] < this.pasajeros.length) {
          index = this.pasajeros.findIndex(el => el[tipo] === undefined || el[tipo].asiento === undefined)
          let obj = {
            index,
            tipo,
            data: {
              asiento: butaca.title,
              label: butaca.label,
              r,
              c
            }
          }
          this.$store.commit('SET_PASAJERO', obj)
          this.n[this.tab]++
          if (this.n[this.tab] === this.pasajeros.length) {
            this.errores[this.tab] = false
            this.$forceUpdate()
          }
          butaca.checked = true
          butaca.class = 'checked'
        }
      } else {
        index = this.pasajeros.findIndex(el => el[tipo] === undefined || el[tipo].asiento === butaca.title)
        if (index >= 0 && index < this.pasajeros.length) {
          butaca.label = this.pasajeros[index][tipo].label
        }
        let obj = {
          index,
          tipo,
          data: {
            asiento: undefined,
            label: undefined,
            r: undefined,
            c: undefined
          }
        }
        this.$store.commit('SET_PASAJERO', obj)
        this.n[this.tab]--
        butaca.checked = false
        butaca.class = ''
      }
    },

    getClass (butaca) {
      let clase = butaca.class || ''
      if (this.barco.preferenciales?.includes(butaca.title)) {
        clase += ' butaca_preferencial'
      }
      clase += ' butaca'
      return clase
    },

    deshabilitar () {
      if (this.$store.state.tipo_viaje === 'ida') {
        let flag = this.pasajeros.length !== this.n[0]
        this.errores[0] = flag
        return flag
      } else {
        let flag0 = this.pasajeros.length !== this.n[0]
        let flag1 = this.pasajeros.length !== this.n[1]
        this.errores[0] = flag0
        this.errores[1] = flag1
        return flag0 || flag1
      }
    },

    validar () {
      if (this.deshabilitar()) {
        let txt = 'Seleccione todas las butacas'
        if (this.tipo_viaje === 'vuelta') {
          txt = 'Seleccione todas las butacas de ida y de vuelta'
        }
        this.$store.dispatch('notify', {
          color: 'error',
          text: txt,
          icon: 'mdi-alert-circle',
          timeout: 5000
        })
        this.$forceUpdate()
        return
      }
      this.continuar()
    },

    async continuar () {
      await this.$store.dispatch('preReserva')
      this.$emit('next')
    }
  }
}

</script>

<style type="text/css">

.butacas {
  overflow: auto;
  white-space: nowrap;
  height: 100%;
  border: solid 1px #6c6c6c;
}

.butaca {
  background: url('../../../public/images/morado_disponible.png') no-repeat;
  width: 20px;
  height: 20px;
  margin: 1px;
  cursor: pointer;
  display: inline-flex;
}

.butaca_preferencial {
  background: url('../../../public/images/preferencial_disponible.png') no-repeat;
  width: 20px;
  height: 20px;
  margin: 1px;
  cursor: pointer;
  display: inline-flex;
}

.butaca.disabled {
  opacity: 0;
  width: 20px;
  height: 20px;
  cursor: default;
}

.butaca.checked {
  background: url('../../../public/images/morado_seleccionado.png') no-repeat;
  border-radius: 0px;
  line-height: 0px;
  border: 0px;
  width: 20px;
  height: 20px;
}

.butaca_preferencial.checked {
  background: url('../../../public/images/preferencial_seleccionado.png') no-repeat;
  border-radius: 0px;
  line-height: 0px;
  border: 0px;
  width: 20px;
  height: 20px;
}

.butaca.nodisponible {
  background: url('../../../public/images/nodisponible.png') no-repeat;
  cursor: not-allowed;
  border-radius: 0px;
  line-height: 0px;
  border: 0px;
  width: 20px;
  height: 20px;
}

</style>
